import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿La guía me dice qué marcas comprar?',
    a: 'Te enseña los criterios de calidad y, si lo deseas, puedes contactarme para recomendaciones específicas de marcas que yo personalmente avalo.'
  }, {
    q: '¿Es muy técnica?',
    a: 'Al contrario, está escrita de forma 100% práctica con tablas visuales.'
  }, {
    q: '¿Recibo algo físico?',
    a: 'Es una guía digital de acceso inmediato para que empieces hoy mismo.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <Section bg="cream-dark" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl border border-sage-200 overflow-hidden shadow-sm" data-id="element-5">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-6">
                <span className="text-lg font-bold text-sage-900" data-id="element-7">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sage-500 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-8" />
              </button>

              <AnimatePresence data-id="element-9">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-10">
                    <div className="px-6 pb-6 text-charcoal-light border-t border-sage-50 pt-4" data-id="element-11">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}